import { Select, Field } from "@zendeskgarden/react-forms";
import type { ZenSelectProps } from "./interface";
import { SelectContainer } from "./style";

export function ZenSelect({ label, placeholder, options, value, disabled, onChange }: ZenSelectProps) {
  return (
    <SelectContainer>
      {label && <Field.Label>{label}</Field.Label>}
      <Select
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.value)}
      >
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </SelectContainer>
  );
}
